module.exports = __webpack_public_path__ + "img/Male-active.0f685140.svg";